import { Screen } from '~/screens/Portal';

export const Portal: React.FC = () => <Screen />;
